var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFocus2Line = function SvgFocus2Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.5 19.2a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4m0 1.8a9 9 0 0 1-9-9 9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9m0-5.4a3.6 3.6 0 1 0 0-7.2 3.6 3.6 0 0 0 0 7.2m0 1.8a5.4 5.4 0 1 1 0-10.8 5.4 5.4 0 0 1 0 10.8m0-3.6a1.8 1.8 0 1 1 0-3.6 1.8 1.8 0 0 1 0 3.6"
  })));
};
export default SvgFocus2Line;